import { MESSAGE } from '@vindr/services/constants/message.constant';
import { Form } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TextEditor, { TextEditorProps } from '../../../ui/TextEditor';
import { FormItemProps } from '../templates/FormProps';

export type FormTextEditorProps<T> = Omit<FormItemProps<T>, 'placeholder' | 'multiple'> &
  TextEditorProps & {
    content: string;
    height?: number;
    placeholder?: string;
  };

const FormTextEditor = <T,>({
  name,
  label,
  rules,
  disabled,
  content,
  form,
  required,
  height,
  className,
  noStyle,
  placeholder = '',
  ...props
}: FormTextEditorProps<T>): JSX.Element => {
  const { t } = useTranslation('Vindoc');

  const rulesMemo = useMemo(() => {
    const rulesState = [];

    if (required) rulesState.push({ required: true, message: t(MESSAGE.INLINE.IEM_0001) });
    if (rules) rulesState.push(...rules);

    return rulesState;
  }, [t, rules, required]);

  return (
    <Form.Item
      name={name}
      {...(label && { label: t(label) })}
      {...((rules || required) && { rules: rulesMemo })}
      className={className}
      noStyle={noStyle}
    >
      <TextEditor
        content={content}
        disabled={disabled}
        form={form}
        height={height}
        name={name}
        initProps={{
          forced_root_block: 'div',
          placeholder: t(placeholder),
          mergetags_prefix: '{{{',
          mergetags_suffix: '}}}',
        }}
        {...props}
      />
    </Form.Item>
  );
};

export default FormTextEditor;
